module.exports = __webpack_public_path__ + "templates.facebook-messenger-checkbox-974c5361.html";